<template>
    <div class="events">
        <h1 class="title">·大雅乐盟大事记</h1>

        <!-- <p class="desc">2018年全国设立分部共计25个，其中新增合作学校68所，新增团员3960人，取得各类奖项60个 <br/>
        2019年大雅将聚焦“打造平台+服务的职能型总部”、“合伙人文化的建立与制度推行”、“搭建线上音乐教室”、“建立小型活动常规化、大型活动制度化的交流平台”、“第三期指挥培训班培训工作”</p> -->

        <div class="timer">
            <img src="@/assets/images/events.png" width="80%" alt="">
        </div>
    </div>
</template>

<style lang="less" scoped>
    .events {
        box-shadow:0px 2px 4px 0px rgba(0,0,0,0.11);
        .title {
            padding-top: 25px;
            padding-left: 32px;
            color: #08433F;
            font-size: 25px;
            line-height: 55px;
        }
        .desc {
            padding-left: 48px;
            color: #7f7f7f;
            font-size: 14px;
            line-height: 20px;
        }

        .timer {
            padding: 30px 0 100px 48px;
        }
    }
</style>

<script>
export default {
    name: 'events'
}
</script>
